import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ButtonClose from "../../../components/Buttons/ButtonClose";
import classes from "./Notify.module.scss";
// import { useSelector } from "react-redux";
// import { isTemplateSpan } from "typescript";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

const Notify = () => {
  // const { activeUser, session } = useSelector((state) => state.session);
  // const { plans, plans_error } = useSelector((state) => state.plans);
  // const plans = session?.plans;
  const { t } = useTranslation();
  const remove = (arr, item) => {
    const newArr = [...arr];
    newArr.splice(
      newArr.findIndex((i) => i === item),
      1
    );
    return newArr;
  };

  let newIndex = 0;
  const add = (arr) => {
    newIndex++;
    return [...arr, newIndex];
  };

  const [notifications, setNotifications] = useState([]);
  const [notifyTry, setNotifyTry] = useState(true);
  // useEffect(() => {
  //   if (plans) {
  //     getNotify();
  //   }
  // }, [plans]);

  // function getNotify() {
  //   return;
  //   let newPlans;

  //   newPlans = plans.plans.filter(
  //     (item) => item.is_legacy === "false" && item.status === "active"
  //   );

  //   if (newPlans.length > 1 && notifications.length === 0) {
  //     setNotifications(add(notifications));
  //   } else {
  //     return;
  //   }
  // }
  const handleNotificationClick = () => {
    if ("Notification" in window) {
      setNotifications([]);
      setNotifyTry(false)
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          new Notification("Notificações ativadas", {
            icon: "https://novo.afinandoocerebro.com.br/static/media/logo_afinando.0b83e625.png",
            body: "Agora você receberá notificações do nosso site!",
          });
        }
      });
    }
  };

  useEffect(() => {
    if ("Notification" in window) {
      if (Notification.permission !== "denied") {
        // As notificações não estão ativas, mas o usuário ainda não negou a permissão
        // Você pode solicitar permissão aqui
        if (Notification.permission !== "granted") {

          const checkNotifyEnable = setTimeout(() => {
            if (Notification.permission === "granted" || notifyTry===false)
              clearTimeout(checkNotifyEnable)
            else if (notifications.length===0)
              setNotifications(add(notifications));
          }, 5000);
        }
        /* Notification.requestPermission().then(function (permission) {
          if (permission === "granted") {
            console.log("notificações permitidas.");
            // // Permissão concedida, você pode enviar notificações aqui
            // new Notification("Título da Notificação", {
            //   body: "Esta é uma notificação de exemplo."
            // });
          } else {
            // O usuário negou a permissão para notificações
            console.log("O usuário negou permissão para notificações.");
          }
        }); */
      }
    }
  });

  return (
    <div className="container">
      <ul className={classes.notifyUl}>
        <AnimatePresence initial={false}>
          {notifications.map((id) => (
            <motion.li
              key={id}
              className={classes.notifyList}
              positionTransition
              initial={{ opacity: 0, y: 50, scale: 0.3 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, scale: 0.5, transition: { duration: 0.2 } }}
            >
              <ButtonClose
                classCss={classes.buttonClose}
                close={() => {
                  setNotifications(remove(notifications, id))
                  setNotifyTry(false)
                }}
              />

              <div>
                <h1>
                  <FontAwesomeIcon icon={faBell}></FontAwesomeIcon>{" "}
                  {t("global.notify")}
                </h1>
                <p>{t("global.activeNotifyMsg")}</p>
                <p className={classes.buttonNotifyContainer}>
                  <button
                    className={classes.buttonNotify}
                    onClick={handleNotificationClick}
                  >
                    {t("global.activeNotify")}
                  </button>
                </p>
              </div>
            </motion.li>
          ))}
        </AnimatePresence>
      </ul>
      {/* <button
        className="add"
        onClick={() => setNotifications(add(notifications))}
      >
        BUTTON +
      </button> */}
    </div>
  );
};
export default Notify;
